import {
    CircularProgress, makeStyles, Button, TextField, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions,
    Backdrop, Checkbox, FormControlLabel, Table, TableHead, TableRow, TableCell, TableBody
} from '@material-ui/core';
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TablePaginatedPay from 'widgets/Tables/TablePaginatedPay';
import TableSimple from 'widgets/Tables/TableSimple';
import tableStyle from "configurations/styles/table";
import clientBackend, { clientPay } from 'configurations/axios';
import { msmSwalExito, msmSwalError } from 'configurations/styles/theme';
import { apiKey } from "configurations/constant";
import { valorIva } from 'views/facturacion/Forms/typeVoucher';
import {
    API_GET_ALL_PAYMENTS, API_GET_CONTRACTED_BY_COMPANY, API_POST_AUTOMATIC_REGISTER, API_GET_MODULES, API_GET_COMPANIES
} from './apis';
import { getRUCEmpresa, getSub } from 'redux/actions/userActions';
import AcceptPaymentBtn from './Buttons/AcceptPaymentBtn';
import CancelPaymentBtn from './Buttons/CancelPaymentBtn';
import ReviewPaymentBtn from './Buttons/ReviewPaymentBtn';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: "35px",
        paddingBottom: "7%",
        flexGrow: 1,
        paddingLeft: "3%",
        paddingRight: "3%",
    },
    headerBottons: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "16px",
        marginBottom: theme.spacing(2),
    },
    loader: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        height: "300px"
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: theme.palette.primary.main,
    }
}));

const estadosPago = {
    "1": "Voucher No Cargado",
    "2": "Voucher Cargado",
    "3": "Aprobado",
};

const IVA_DEFAULT = "01";

const Payments = () => {

    const classesView = useStyles();
    const tokenUser = useSelector((state) => state.user.tk);
    const [update, setUpdate] = useState(0);
    const [openLoader, setOpenLoader] = useState(false);
    const [modulos, setModulos] = useState([]);
    const [moduloSeleccionado, setModuloSeleccionado] = useState(1);
    const [empresas, setEmpresas] = useState([]);

    //Nuevo registro
    const [openNuevo, setOpenNuevo] = useState(false);
    const [moduloNuevo, setModuloNuevo] = useState(1);
    const [empresaNuevo, setEmpresaNuevo] = useState(null);
    const [cantidad, setCantidad] = useState('');
    const [iva, setIva] = useState(IVA_DEFAULT);
    const [monto, setMonto] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [enviarFactura, setEnviarFactura] = useState(true);

    //Buscar
    const [openBuscar, setOpenBuscar] = useState(false);
    const [empresaBusqueda, setEmpresaBusqueda] = useState(null);
    const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
    const [loadingBuscar, setLoadingBuscar] = useState(false);

    const columns = [
        { title: "RUC", field: "empresaContratante.idempresacontratante", cellStyle: tableStyle.cellTable, width: "8%", },
        { title: "Razón Social/Nombres", field: "empresaContratante.razonSocialempresa", cellStyle: tableStyle.cellLeft, width: "25%", },
        { title: "Plan", field: "paquete.nombre", cellStyle: tableStyle.cellTable, width: "7%", },
        { title: "Total ", field: "valorTotalPaquete", cellStyle: tableStyle.cellTable, width: "7%", render: rowData => rowData.valorTotalPaquete.toFixed(2) },
        { title: "Revisar Pago", cellStyle: tableStyle.cellTable, render: rowData => <ReviewPaymentBtn data={rowData} /> },
        { title: "Aprobar", field: "correo", cellStyle: tableStyle.cellTable, render: rowData => <AcceptPaymentBtn data={rowData} reload={reload} /> },
        { title: "Rechazar", cellStyle: tableStyle.cellTable, render: rowData => <CancelPaymentBtn data={rowData} reload={reload} /> },
    ];

    const requestConfig = {
        uri: API_GET_ALL_PAYMENTS + (tokenUser ? getRUCEmpresa(tokenUser) : "0") + '/' + (moduloSeleccionado || ''),
        metodo: "get",
        body: null,
        page: 0,
        elementos: 15,
        sort: 'codigoAsignacion,desc',
    };

    const reload = () => {
        setUpdate(1);
    };

    useEffect(() => {
        if (update === 1) {
            setUpdate(0);
        }
    }, [update]);

    const fetchModulos = async () => {
        try {
            const response = await clientBackend.get(API_GET_MODULES);
            const data = response.data || [];
            setModulos(data);
            if (data.length > 0 && !data.some(m => m.idModulo === moduloSeleccionado)) {
                setModuloSeleccionado(data[0].idModulo);
                reload();
            }
        } catch (error) {
            msmSwalError("Error al cargar módulos");
        }
    };

    useEffect(() => {
        fetchModulos();
    }, []);

    const fetchEmpresas = async () => {
        try {
            const response = await clientBackend.get(API_GET_COMPANIES + apiKey);
            setEmpresas(response.data?.content || response.data || []);
        } catch (error) {
            msmSwalError("Error al cargar empresas");
        }
    };

    const limpiarNuevo = () => {
        setEmpresaNuevo(null);
        setCantidad('');
        setIva(IVA_DEFAULT);
        setMonto('');
        setDescripcion('');
        setEnviarFactura(true);
    };

    const abrirNuevo = () => {
        fetchEmpresas();
        limpiarNuevo();
        setModuloNuevo(moduloSeleccionado || 1);
        setOpenNuevo(true);
    };

    const enviarNuevo = async () => {
        if (!empresaNuevo || !iva || !monto || !descripcion) {
            msmSwalError("Todos los campos son obligatorios");
            return;
        }
        setOpenLoader(true);
        try {
            await clientPay.post(API_POST_AUTOMATIC_REGISTER, {
                descripcion,
                rucEmpresa: tokenUser ? getRUCEmpresa(tokenUser) : '',
                rucEmpresaReceptora: empresaNuevo.ruc,
                envioFactura: enviarFactura,
                valorSinIva: Number(monto),
                codigoPorcentajeIVA: Number(iva),
                idAsignacionEmpresaUsuario: Number(tokenUser ? getSub(tokenUser) : ''),
                cantidad: Number(cantidad),
                revision: true,
                idAsignacionPaqueteEmpresa: 1,
                idModulo: moduloNuevo
            });
            msmSwalExito("Éxito", "El registro se ha creado correctamente");
            setOpenNuevo(false);
            limpiarNuevo();
            reload();
        } catch (error) {
            msmSwalError(error.response?.data?.apierror?.mensaje || "Error al crear el registro");
        } finally {
            setOpenLoader(false);
        }
    };

    const abrirBuscar = () => {
        fetchEmpresas();
        setOpenBuscar(true);
    };

    const cerrarBuscar = () => {
        setOpenBuscar(false);
        setEmpresaBusqueda(null);
        setResultadosBusqueda([]);
    };

    const buscarContratados = async () => {
        if (!empresaBusqueda) return;
        setLoadingBuscar(true);
        try {
            const response = await clientPay.get(API_GET_CONTRACTED_BY_COMPANY + empresaBusqueda.ruc, {
                params: {
                    page: 0,
                    size: 20,
                    sort: 'idAsignacionPaqueteEmpresa,desc',
                }
            });
            setResultadosBusqueda(response.data?.content || []);
        } catch (error) {
            msmSwalError(error.response?.data?.apierror?.mensaje || "Error en la búsqueda");
        } finally {
            setLoadingBuscar(false);
        }
    };

    const renderEmpresaAutocomplete = (value, onChange) => (
        <Autocomplete
            options={empresas}
            getOptionLabel={(option) => option ? `${option.ruc} - ${option.razonSocial}` : ""}
            getOptionSelected={(option, selected) => option.ruc === selected.ruc}
            value={value}
            onChange={(e, newValue) => onChange(newValue)}
            renderInput={(params) => (
                <TextField {...params} label="Selecciona Empresa" variant="outlined" margin="dense" fullWidth />
            )}
        />
    );

    const renderModuloOptions = () => modulos.map((modulo) => (
        <MenuItem key={modulo.idModulo} value={modulo.idModulo}>
            {modulo.idModulo + " - " + modulo.nombre}
        </MenuItem>
    ));

    const renderTable = () => {
        switch (update) {
            case 0:
                return (
                    <TablePaginatedPay
                        title=""
                        columns={columns}
                        requestConfig={requestConfig}
                        seleccion={false}
                    />
                );

            case 1:
            case 3:
                return (
                    <div className={classesView.loader}>
                        <CircularProgress />
                    </div>
                );
            case 2:
                return (
                    <TableSimple
                        columns={columns}
                        data={''}
                        title=""
                        numberRowsPerPage={15}
                    />
                );
            default:
                break;
        }
    };

    return (
        <div className={classesView.root}>
            <div className={classesView.headerBottons}>
                <TextField
                    select
                    label="Módulo"
                    value={modulos.length > 0 ? moduloSeleccionado : ''}
                    onChange={(e) => {
                        setModuloSeleccionado(e.target.value);
                        reload();
                    }}
                    variant="outlined"
                    size="small"
                    style={{ width: 220 }}
                >
                    {renderModuloOptions()}
                </TextField>
                <Button variant="contained" color="primary" onClick={abrirNuevo}>
                    Nuevo
                </Button>
                <Button variant="contained" color="primary" onClick={abrirBuscar}>
                    Buscar
                </Button>
            </div>

            {renderTable()}

            <Dialog open={openNuevo} onClose={() => setOpenNuevo(false)}>
                <DialogTitle>Nuevo Registro</DialogTitle>
                <DialogContent>
                    <TextField
                        select
                        label="Módulo"
                        value={modulos.length > 0 ? moduloNuevo : ''}
                        onChange={(e) => setModuloNuevo(e.target.value)}
                        fullWidth
                        margin="dense"
                        style={{ marginBottom: 16 }}
                    >
                        {renderModuloOptions()}
                    </TextField>
                    {renderEmpresaAutocomplete(empresaNuevo, setEmpresaNuevo)}
                    <TextField
                        label="Cantidad"
                        value={cantidad}
                        onChange={(e) => {
                            if (/^[0-9]*$/.test(e.target.value)) {
                                setCantidad(e.target.value);
                            }
                        }}
                        fullWidth
                        margin="dense"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                    />
                    <TextField
                        select
                        label="ITBMS"
                        value={iva}
                        onChange={(e) => setIva(e.target.value)}
                        fullWidth
                        margin="dense"
                    >
                        {valorIva.map((item) => (
                            <MenuItem key={item.CODIGO} value={item.CODIGO}>{item.NOMBRE}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Precio Sin Impuestos"
                        value={monto}
                        onChange={(e) => setMonto(e.target.value)}
                        fullWidth
                        margin="dense"
                        type="number"
                        inputProps={{ step: "0.01", min: 0 }}
                    />
                    <TextField
                        label="Descripción"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                        fullWidth
                        margin="dense"
                    />
                    <FormControlLabel
                        style={{ marginTop: 8 }}
                        control={
                            <Checkbox
                                checked={enviarFactura}
                                onChange={(e) => setEnviarFactura(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Enviar factura"
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="default" onClick={() => setOpenNuevo(false)} style={{ marginRight: 8 }}>
                        Cancelar
                    </Button>
                    <Button variant="contained" color="primary" onClick={enviarNuevo}>
                        Enviar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openBuscar} onClose={cerrarBuscar} maxWidth="md" fullWidth>
                <DialogTitle>Buscar Clientes por Empresa</DialogTitle>
                <DialogContent>
                    {renderEmpresaAutocomplete(empresaBusqueda, setEmpresaBusqueda)}
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!empresaBusqueda || loadingBuscar}
                        onClick={buscarContratados}
                        style={{ marginTop: 16 }}
                    >
                        {loadingBuscar ? "Buscando..." : "Buscar"}
                    </Button>

                    {resultadosBusqueda.length > 0 && (
                        <Table size="small" style={{ marginTop: 16 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Contratados</TableCell>
                                    <TableCell>Usados</TableCell>
                                    <TableCell>Disponible</TableCell>
                                    <TableCell>Estado</TableCell>
                                    <TableCell>Fecha Inicio</TableCell>
                                    <TableCell>Fecha Fin</TableCell>
                                    <TableCell>Módulo</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {resultadosBusqueda.map((item) => (
                                    <TableRow key={item.idAsignacionPaqueteEmpresa}>
                                        <TableCell>{item.cantidadComprobantesContratados}</TableCell>
                                        <TableCell>{item.cantidadComprobantesUtilizados}</TableCell>
                                        <TableCell>{item.cantidadComprobantesDisponibles}</TableCell>
                                        <TableCell>{estadosPago[item.estadoPago] || item.estadoPago}</TableCell>
                                        <TableCell>{item.fechaInicioContratacion ? new Date(item.fechaInicioContratacion).toLocaleDateString() : ''}</TableCell>
                                        <TableCell>{item.fechaFinContratacion ? new Date(item.fechaFinContratacion).toLocaleDateString() : ''}</TableCell>
                                        <TableCell>{item.paquete?.modulo?.nombre || "NA"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="default" onClick={cerrarBuscar}>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>

            <Backdrop className={classesView.backdrop} open={openLoader}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default Payments;
